import type { PiralPlugin } from 'piral-core'

declare module 'piral-core/lib/types/custom' {
  interface PiletCustomApi extends ConfigApi {}
}

export interface ConfigApi {
  storageKeyPrefix(): string
  wrwksShort(): string
  wrwksLong(): string
  wrwksTitle(): string
}

export function createConfigApi(): PiralPlugin<ConfigApi> {
  return () => {
    return {
      storageKeyPrefix(): string {
        return __STORAGE_KEY_PREFIX__
      },
      wrwksShort(): string {
        return __WRWKS_SHORT__
      },
      wrwksLong(): string {
        return __WRWKS_LONG__
      },
      wrwksTitle(): string {
        return __WRWKS_TITLE__
      }
    }
  }
}
